// import {
//   FETCH_MAILER_REQUEST,
//   FETCH_MAILER_SUCCESS,
//   FETCH_MAILER_ERROR,
//   FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST,
//   FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
//   FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR,
//   FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST,
//   FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
//   FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR,
//   FETCH_ALL_MEASURES_REQUEST,
//   FETCH_ALL_MEASURES_SUCCESS,
//   FETCH_ALL_MEASURES_ERROR,
//   FETCH_ALL_METRICS_REQUEST,
//   FETCH_ALL_METRICS_SUCCESS,
//   FETCH_ALL_METRICS_ERROR,
//   CREATE_SCHEDULED_REPORT_REQUEST,
//   CREATE_SCHEDULED_REPORT_SUCCESS,
//   CREATE_SCHEDULED_REPORT_ERROR,
//   UPDATE_SCHEDULED_REPORT_REQUEST,
//   UPDATE_SCHEDULED_REPORT_SUCCESS,
//   UPDATE_SCHEDULED_REPORT_ERROR,
//   DELETE_SCHEDULED_REPORT_REQUEST,
//   DELETE_SCHEDULED_REPORT_SUCCESS,
//   DELETE_SCHEDULED_REPORT_ERROR,
//   TOGGLE_REPORT_STATUS_REQUEST,
//   TOGGLE_REPORT_STATUS_SUCCESS,
//   TOGGLE_REPORT_STATUS_ERROR,
//   RESET_MAILER_DATA,
//   RESET_MAILER_ERROR,
//   SET_SELECTED_MAILER_DATA,
//   SET_MAILER_FORM_DATA
// } from './mailerTypes';

// import BASE_URL from '../config';
// import axios from 'axios';

// axios.defaults.timeout = 120000;
// const timeout = 120000;

// // Generic request action
// export const fetchMailerRequest = (msg) => {
//   return {
//     type: FETCH_MAILER_REQUEST,
//     payload: msg
//   };
// };

// // Generic success action
// export const fetchMailerSuccess = (data) => {
//   return {
//     type: FETCH_MAILER_SUCCESS,
//     payload: data
//   };
// };

// // Generic error action
// export const fetchMailerError = (error) => {
//   return {
//     type: FETCH_MAILER_ERROR,
//     payload: error
//   };
// };

// // Reset actions
// export const resetMailerData = () => {
//   return {
//     type: RESET_MAILER_DATA
//   };
// };

// export const resetMailerError = () => {
//   return {
//     type: RESET_MAILER_ERROR
//   };
// };

// // Set selected data
// export const setSelectedMailerData = (data) => {
//   return {
//     type: SET_SELECTED_MAILER_DATA,
//     payload: data
//   };
// };

// export const setMailerFormData = (data) => {
//   return {
//     type: SET_MAILER_FORM_DATA,
//     payload: data
//   };
// };

// // Fetch user reporting emailer details
// export const fetchUserReportingEmailerDetailsRequest = () => {
//   return {
//     type: FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST
//   };
// };

// export const fetchUserReportingEmailerDetailsSuccess = (data) => {
//   return {
//     type: FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
//     payload: data
//   };
// };

// export const fetchUserReportingEmailerDetailsError = (error) => {
//   return {
//     type: FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR,
//     payload: error
//   };
// };

// // Fetch all user reporting emailer details
// export const fetchAllUserReportingEmailerDetailsRequest = () => {
//   return {
//     type: FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST
//   };
// };

// export const fetchAllUserReportingEmailerDetailsSuccess = (data) => {
//   return {
//     type: FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
//     payload: data.result || data // Handle both {result: [...]} and direct array
//   };
// };

// export const fetchAllUserReportingEmailerDetailsError = (error) => {
//   return {
//     type: FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR,
//     payload: error
//   };
// };

// // Fetch all measures
// export const fetchAllMeasuresRequest = () => {
//   return {
//     type: FETCH_ALL_MEASURES_REQUEST
//   };
// };

// export const fetchAllMeasuresSuccess = (data) => {
//   return {
//     type: FETCH_ALL_MEASURES_SUCCESS,
//     payload: Array.isArray(data) ? data : data.result || []
//   };
// };

// export const fetchAllMeasuresError = (error) => {
//   return {
//     type: FETCH_ALL_MEASURES_ERROR,
//     payload: error
//   };
// };

// // Fetch all metrics
// export const fetchAllMetricsRequest = () => {
//   return {
//     type: FETCH_ALL_METRICS_REQUEST
//   };
// };

// export const fetchAllMetricsSuccess = (data) => {
//   return {
//     type: FETCH_ALL_METRICS_SUCCESS,
//     payload: Array.isArray(data) ? data : data.result || []
//   };
// };

// export const fetchAllMetricsError = (error) => {
//   return {
//     type: FETCH_ALL_METRICS_ERROR,
//     payload: error
//   };
// };

// // API Action Creators

// // Fetch user reporting emailer details by email
// export const fetchUserReportingEmailerDetails = (email) => (dispatch) => {
//   dispatch(fetchUserReportingEmailerDetailsRequest());

//   axios({
//     method: 'post',
//     url: `${BASE_URL}/getUserReportingEmailerDetails`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: {
//       email: email
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data && response.data.data) {
//         dispatch(fetchUserReportingEmailerDetailsSuccess(response.data.data));
//       } else {
//         dispatch(fetchUserReportingEmailerDetailsError('No data found'));
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to fetch user reporting emailer details. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch(fetchUserReportingEmailerDetailsError(errorMessage));
//     });
// };

// // Update the API call handlers to properly extract data
// export const fetchAllUserReportingEmailerDetails = () => (dispatch) => {
//   dispatch(fetchAllUserReportingEmailerDetailsRequest());

//   axios({
//     method: 'post',
//     url: `${BASE_URL}/getAllUserReportingEmailerDetails`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       // FIXED: Handle nested data structure
//       if (response.data && response.data.data && response.data.data.result) {
//         dispatch(fetchAllUserReportingEmailerDetailsSuccess(response.data.data.result));
//       } else if (response.data && response.data.result) {
//         dispatch(fetchAllUserReportingEmailerDetailsSuccess(response.data.result));
//       } else {
//         dispatch(fetchAllUserReportingEmailerDetailsError('No data found'));
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to fetch user reporting emailer details. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch(fetchAllUserReportingEmailerDetailsError(errorMessage));
//     });
// };

// /// Update measures API call
// export const fetchAllMeasures = () => (dispatch) => {
//   dispatch(fetchAllMeasuresRequest());

//   axios({
//     method: 'post',
//     url: `${BASE_URL}/getAllMeasures`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       // FIXED: Handle different response structures
//       let measures = [];
//       if (response.data && response.data.data && Array.isArray(response.data.data)) {
//         measures = response.data.data;
//       } else if (response.data && Array.isArray(response.data)) {
//         measures = response.data;
//       } else if (response.data && response.data.result && Array.isArray(response.data.result)) {
//         measures = response.data.result;
//       }

//       dispatch(fetchAllMeasuresSuccess(measures));
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to fetch measures. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch(fetchAllMeasuresError(errorMessage));
//     });
// };

// // Update metrics API call
// export const fetchAllMetrics = () => (dispatch) => {
//   dispatch(fetchAllMetricsRequest());

//   axios({
//     method: 'post',
//     url: `${BASE_URL}/getAllMetrics`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       // FIXED: Handle different response structures
//       let metrics = [];
//       if (response.data && response.data.data && Array.isArray(response.data.data)) {
//         metrics = response.data.data;
//       } else if (response.data && Array.isArray(response.data)) {
//         metrics = response.data;
//       } else if (response.data && response.data.result && Array.isArray(response.data.result)) {
//         metrics = response.data.result;
//       }

//       dispatch(fetchAllMetricsSuccess(metrics));
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to fetch metrics. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch(fetchAllMetricsError(errorMessage));
//     });
// };
// // Create scheduled report
// export const createScheduledReport = (reportData) => (dispatch) => {
//   dispatch({ type: CREATE_SCHEDULED_REPORT_REQUEST });

//   axios({
//     method: 'post',
//     url: `${BASE_URL}/createScheduledReport`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: reportData,
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: CREATE_SCHEDULED_REPORT_SUCCESS, payload: response.data });
//         // Refresh the list after creating
//         dispatch(fetchAllUserReportingEmailerDetails());
//       } else {
//         dispatch({ type: CREATE_SCHEDULED_REPORT_ERROR, payload: 'Failed to create report' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to create scheduled report. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch({ type: CREATE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
//     });
// };

// // Update scheduled report
// export const updateScheduledReport = (reportId, reportData) => (dispatch) => {
//   dispatch({ type: UPDATE_SCHEDULED_REPORT_REQUEST });

//   axios({
//     method: 'put',
//     url: `${BASE_URL}/updateScheduledReport/${reportId}`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: reportData,
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: UPDATE_SCHEDULED_REPORT_SUCCESS, payload: response.data });
//         // Refresh the list after updating
//         dispatch(fetchAllUserReportingEmailerDetails());
//       } else {
//         dispatch({ type: UPDATE_SCHEDULED_REPORT_ERROR, payload: 'Failed to update report' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to update scheduled report. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch({ type: UPDATE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
//     });
// };

// // Delete scheduled report
// export const deleteScheduledReport = (reportId) => (dispatch) => {
//   dispatch({ type: DELETE_SCHEDULED_REPORT_REQUEST });

//   axios({
//     method: 'delete',
//     url: `${BASE_URL}/deleteScheduledReport/${reportId}`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: DELETE_SCHEDULED_REPORT_SUCCESS, payload: reportId });
//         // Refresh the list after deleting
//         dispatch(fetchAllUserReportingEmailerDetails());
//       } else {
//         dispatch({ type: DELETE_SCHEDULED_REPORT_ERROR, payload: 'Failed to delete report' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to delete scheduled report. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch({ type: DELETE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
//     });
// };

// // Toggle report status
// export const toggleReportStatus = (reportId, isActive) => (dispatch) => {
//   dispatch({ type: TOGGLE_REPORT_STATUS_REQUEST });

//   axios({
//     method: 'patch',
//     url: `${BASE_URL}/toggleReportStatus/${reportId}`,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: { active: isActive },
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: TOGGLE_REPORT_STATUS_SUCCESS, payload: response.data });
//         // Refresh the list after toggling status
//         dispatch(fetchAllUserReportingEmailerDetails());
//       } else {
//         dispatch({ type: TOGGLE_REPORT_STATUS_ERROR, payload: 'Failed to toggle report status' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to toggle report status. Please retry';
//       if (error.response && error.response.data && error.response.data.message) {
//         errorMessage = error.response.data.message;
//       }
//       dispatch({ type: TOGGLE_REPORT_STATUS_ERROR, payload: errorMessage });
//     });
// };

import {
  FETCH_MAILER_REQUEST,
  FETCH_MAILER_SUCCESS,
  FETCH_MAILER_ERROR,
  FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST,
  FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
  FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR,
  FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST,
  FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
  FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR,
  FETCH_ALL_MEASURES_REQUEST,
  FETCH_ALL_MEASURES_SUCCESS,
  FETCH_ALL_MEASURES_ERROR,
  FETCH_ALL_METRICS_REQUEST,
  FETCH_ALL_METRICS_SUCCESS,
  FETCH_ALL_METRICS_ERROR,
  CREATE_SCHEDULED_REPORT_REQUEST,
  CREATE_SCHEDULED_REPORT_SUCCESS,
  CREATE_SCHEDULED_REPORT_ERROR,
  UPDATE_SCHEDULED_REPORT_REQUEST,
  UPDATE_SCHEDULED_REPORT_SUCCESS,
  UPDATE_SCHEDULED_REPORT_ERROR,
  DELETE_SCHEDULED_REPORT_REQUEST,
  DELETE_SCHEDULED_REPORT_SUCCESS,
  DELETE_SCHEDULED_REPORT_ERROR,
  TOGGLE_REPORT_STATUS_REQUEST,
  TOGGLE_REPORT_STATUS_SUCCESS,
  TOGGLE_REPORT_STATUS_ERROR,
  RESET_MAILER_DATA,
  RESET_MAILER_ERROR,
  SET_SELECTED_MAILER_DATA,
  SET_MAILER_FORM_DATA
} from './mailerTypes';

import BASE_URL from '../config';
import axios from 'axios';

axios.defaults.timeout = 120000;
const timeout = 120000;

// Generic request action
export const fetchMailerRequest = (msg) => {
  return {
    type: FETCH_MAILER_REQUEST,
    payload: msg
  };
};

// Generic success action
export const fetchMailerSuccess = (data) => {
  return {
    type: FETCH_MAILER_SUCCESS,
    payload: data
  };
};

// Generic error action
export const fetchMailerError = (error) => {
  return {
    type: FETCH_MAILER_ERROR,
    payload: error
  };
};

// Reset actions
export const resetMailerData = () => {
  return {
    type: RESET_MAILER_DATA
  };
};

export const resetMailerError = () => {
  return {
    type: RESET_MAILER_ERROR
  };
};

// Set selected data
export const setSelectedMailerData = (data) => {
  return {
    type: SET_SELECTED_MAILER_DATA,
    payload: data
  };
};

export const setMailerFormData = (data) => {
  return {
    type: SET_MAILER_FORM_DATA,
    payload: data
  };
};

// Fetch user reporting emailer details
export const fetchUserReportingEmailerDetailsRequest = () => {
  return {
    type: FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST
  };
};

export const fetchUserReportingEmailerDetailsSuccess = (data) => {
  return {
    type: FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
    payload: data
  };
};

export const fetchUserReportingEmailerDetailsError = (error) => {
  return {
    type: FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR,
    payload: error
  };
};

// Fetch all user reporting emailer details
export const fetchAllUserReportingEmailerDetailsRequest = () => {
  return {
    type: FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST
  };
};

export const fetchAllUserReportingEmailerDetailsSuccess = (data) => {
  return {
    type: FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS,
    payload: data.result || data
  };
};

export const fetchAllUserReportingEmailerDetailsError = (error) => {
  return {
    type: FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR,
    payload: error
  };
};

// Fetch all measures
export const fetchAllMeasuresRequest = () => {
  return {
    type: FETCH_ALL_MEASURES_REQUEST
  };
};

export const fetchAllMeasuresSuccess = (data) => {
  return {
    type: FETCH_ALL_MEASURES_SUCCESS,
    payload: Array.isArray(data) ? data : data.result || []
  };
};

export const fetchAllMeasuresError = (error) => {
  return {
    type: FETCH_ALL_MEASURES_ERROR,
    payload: error
  };
};

// Fetch all metrics
export const fetchAllMetricsRequest = () => {
  return {
    type: FETCH_ALL_METRICS_REQUEST
  };
};

export const fetchAllMetricsSuccess = (data) => {
  return {
    type: FETCH_ALL_METRICS_SUCCESS,
    payload: Array.isArray(data) ? data : data.result || []
  };
};

export const fetchAllMetricsError = (error) => {
  return {
    type: FETCH_ALL_METRICS_ERROR,
    payload: error
  };
};

// API Action Creators

// Fetch user reporting emailer details by email
export const fetchUserReportingEmailerDetails = (email) => (dispatch) => {
  dispatch(fetchUserReportingEmailerDetailsRequest());

  axios({
    method: 'post',
    url: `${BASE_URL}/getUserReportingEmailerDetails`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      email: email
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data && response.data.data) {
        dispatch(fetchUserReportingEmailerDetailsSuccess(response.data.data));
      } else {
        dispatch(fetchUserReportingEmailerDetailsSuccess([]));
      }
    })
    .catch((error) => {
      let errorMessage = 'Not able to fetch user reporting emailer details. Please retry';
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      dispatch(fetchUserReportingEmailerDetailsError(errorMessage));
    });
};

// Fetch all user reporting emailer details
export const fetchAllUserReportingEmailerDetails = () => (dispatch) => {
  dispatch(fetchAllUserReportingEmailerDetailsRequest());

  axios({
    method: 'post',
    url: `${BASE_URL}/getAllUserReportingEmailerDetails`,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: timeout
  })
    .then((response) => {
      if (response.data && response.data.data && response.data.data.result) {
        dispatch(fetchAllUserReportingEmailerDetailsSuccess(response.data.data.result));
      } else if (response.data && response.data.result) {
        dispatch(fetchAllUserReportingEmailerDetailsSuccess(response.data.result));
      } else {
        dispatch(fetchAllUserReportingEmailerDetailsSuccess([]));
      }
    })
    .catch((error) => {
      let errorMessage = 'Not able to fetch user reporting emailer details. Please retry';
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      dispatch(fetchAllUserReportingEmailerDetailsError(errorMessage));
    });
};

// Fetch all measures
export const fetchAllMeasures = () => (dispatch) => {
  dispatch(fetchAllMeasuresRequest());

  axios({
    method: 'post',
    url: `${BASE_URL}/getAllMeasures`,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: timeout
  })
    .then((response) => {
      let measures = [];
      if (response.data && response.data.data && response.data.data.result && Array.isArray(response.data.data.result)) {
        measures = response.data.data.result;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        measures = response.data.data;
      } else if (response.data && Array.isArray(response.data)) {
        measures = response.data;
      } else if (response.data && response.data.result && Array.isArray(response.data.result)) {
        measures = response.data.result;
      }

      dispatch(fetchAllMeasuresSuccess(measures));
    })
    .catch((error) => {
      let errorMessage = 'Not able to fetch measures. Please retry';
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      dispatch(fetchAllMeasuresError(errorMessage));
    });
};

// Fetch all metrics
export const fetchAllMetrics = () => (dispatch) => {
  dispatch(fetchAllMetricsRequest());

  axios({
    method: 'post',
    url: `${BASE_URL}/getAllMetrics`,
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: timeout
  })
    .then((response) => {
      let metrics = [];
      if (response.data && response.data.data && response.data.data.result && Array.isArray(response.data.data.result)) {
        metrics = response.data.data.result;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        metrics = response.data.data;
      } else if (response.data && Array.isArray(response.data)) {
        metrics = response.data;
      } else if (response.data && response.data.result && Array.isArray(response.data.result)) {
        metrics = response.data.result;
      }

      dispatch(fetchAllMetricsSuccess(metrics));
    })
    .catch((error) => {
      let errorMessage = 'Not able to fetch metrics. Please retry';
      if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }
      dispatch(fetchAllMetricsError(errorMessage));
    });
};

// // Create scheduled report - Updated to use backend API structure
// export const createScheduledReport = (reportData) => (dispatch) => {
//   dispatch({ type: CREATE_SCHEDULED_REPORT_REQUEST });

//   // Use the backend API endpoint that matches your Python function
//   axios({
//     method: 'post',
//     url: `${BASE_URL}/updateEmailReportingDetails`, // This maps to update_email_reporting_details
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: reportData, // reportData should have structure: { email_id, report_details }
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: CREATE_SCHEDULED_REPORT_SUCCESS, payload: response.data });
//         // Refresh the user's data after creating
//         dispatch(fetchUserReportingEmailerDetails(reportData.email_id));
//       } else {
//         dispatch({ type: CREATE_SCHEDULED_REPORT_ERROR, payload: 'Failed to create report' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to create scheduled report. Please retry';
//       if (error.response && error.response.data && error.response.data.error) {
//         errorMessage = error.response.data.error;
//       }
//       dispatch({ type: CREATE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
//     });
// };

// // Update scheduled report - Updated to use backend API structure
// export const updateScheduledReport = (email, reportName, reportData) => (dispatch) => {
//   dispatch({ type: UPDATE_SCHEDULED_REPORT_REQUEST });

//   // Use the backend API endpoint that matches your Python function
//   axios({
//     method: 'post',
//     url: `${BASE_URL}/updateEmailReportingDetails`, // This maps to update_email_reporting_details
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: reportData, // reportData should have structure: { email_id, report_details }
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: UPDATE_SCHEDULED_REPORT_SUCCESS, payload: response.data });
//         // Refresh the user's data after updating
//         dispatch(fetchUserReportingEmailerDetails(email));
//       } else {
//         dispatch({ type: UPDATE_SCHEDULED_REPORT_ERROR, payload: 'Failed to update report' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to update scheduled report. Please retry';
//       if (error.response && error.response.data && error.response.data.error) {
//         errorMessage = error.response.data.error;
//       }
//       dispatch({ type: UPDATE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
//     });
// };

// // Delete scheduled report - Updated to use backend API structure
// export const deleteScheduledReport = (email, reportName) => (dispatch) => {
//   dispatch({ type: DELETE_SCHEDULED_REPORT_REQUEST });

//   // Use the backend API endpoint that matches your Python function
//   axios({
//     method: 'post',
//     url: `${BASE_URL}/deleteSchedulerReportStatus`, // This maps to delete_scheduler_report_status
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: {
//       email: email,
//       report_name: reportName
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: DELETE_SCHEDULED_REPORT_SUCCESS, payload: reportName });
//         // Refresh the user's data after deleting
//         dispatch(fetchUserReportingEmailerDetails(email));
//       } else {
//         dispatch({ type: DELETE_SCHEDULED_REPORT_ERROR, payload: 'Failed to delete report' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to delete scheduled report. Please retry';
//       if (error.response && error.response.data && error.response.data.error) {
//         errorMessage = error.response.data.error;
//       }
//       dispatch({ type: DELETE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
//     });
// };

// // Toggle report status - Updated to use backend API structure
// export const toggleReportStatus = (email, reportName, isActive) => (dispatch) => {
//   dispatch({ type: TOGGLE_REPORT_STATUS_REQUEST });

//   // Use the backend API endpoint that matches your Python function
//   axios({
//     method: 'post',
//     url: `${BASE_URL}/updateSchedulerReportStatus`, // This maps to update_scheduler_report_status
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     data: {
//       email: email,
//       report_name: reportName,
//       active: isActive
//     },
//     timeout: timeout
//   })
//     .then((response) => {
//       if (response.data) {
//         dispatch({ type: TOGGLE_REPORT_STATUS_SUCCESS, payload: response.data });
//         // Refresh the user's data after toggling status
//         dispatch(fetchUserReportingEmailerDetails(email));
//       } else {
//         dispatch({ type: TOGGLE_REPORT_STATUS_ERROR, payload: 'Failed to toggle report status' });
//       }
//     })
//     .catch((error) => {
//       let errorMessage = 'Not able to toggle report status. Please retry';
//       if (error.response && error.response.data && error.response.data.error) {
//         errorMessage = error.response.data.error;
//       }
//       dispatch({ type: TOGGLE_REPORT_STATUS_ERROR, payload: errorMessage });
//     });
// };

// Create scheduled report - Updated to refresh all data when needed
export const createScheduledReport =
  (reportData, refreshAll = false) =>
  (dispatch) => {
    dispatch({ type: CREATE_SCHEDULED_REPORT_REQUEST });

    axios({
      method: 'post',
      url: `${BASE_URL}/updateEmailReportingDetails`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: reportData,
      timeout: timeout
    })
      .then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SCHEDULED_REPORT_SUCCESS, payload: response.data });

          // FIXED: Refresh appropriate data based on context
          if (refreshAll) {
            dispatch(fetchAllUserReportingEmailerDetails());
          } else {
            dispatch(fetchUserReportingEmailerDetails(reportData.email_id));
          }
        } else {
          dispatch({ type: CREATE_SCHEDULED_REPORT_ERROR, payload: 'Failed to create report' });
        }
      })
      .catch((error) => {
        let errorMessage = 'Not able to create scheduled report. Please retry';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        dispatch({ type: CREATE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
      });
  };

// Update scheduled report - Updated to refresh all data when needed
export const updateScheduledReport =
  (email, reportName, reportData, refreshAll = false) =>
  (dispatch) => {
    dispatch({ type: UPDATE_SCHEDULED_REPORT_REQUEST });

    axios({
      method: 'post',
      url: `${BASE_URL}/updateEmailReportingDetails`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: reportData,
      timeout: timeout
    })
      .then((response) => {
        if (response.data) {
          dispatch({ type: UPDATE_SCHEDULED_REPORT_SUCCESS, payload: response.data });

          // FIXED: Refresh appropriate data based on context
          if (refreshAll) {
            dispatch(fetchAllUserReportingEmailerDetails());
          } else {
            dispatch(fetchUserReportingEmailerDetails(email));
          }
        } else {
          dispatch({ type: UPDATE_SCHEDULED_REPORT_ERROR, payload: 'Failed to update report' });
        }
      })
      .catch((error) => {
        let errorMessage = 'Not able to update scheduled report. Please retry';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        dispatch({ type: UPDATE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
      });
  };

// Delete scheduled report - Updated to refresh all data when needed
export const deleteScheduledReport =
  (email, reportName, refreshAll = false) =>
  (dispatch) => {
    dispatch({ type: DELETE_SCHEDULED_REPORT_REQUEST });

    axios({
      method: 'post',
      url: `${BASE_URL}/deleteSchedulerReportStatus`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        email: email,
        report_name: reportName
      },
      timeout: timeout
    })
      .then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SCHEDULED_REPORT_SUCCESS, payload: reportName });

          // FIXED: Refresh appropriate data based on context
          if (refreshAll) {
            dispatch(fetchAllUserReportingEmailerDetails());
          } else {
            dispatch(fetchUserReportingEmailerDetails(email));
          }
        } else {
          dispatch({ type: DELETE_SCHEDULED_REPORT_ERROR, payload: 'Failed to delete report' });
        }
      })
      .catch((error) => {
        let errorMessage = 'Not able to delete scheduled report. Please retry';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        dispatch({ type: DELETE_SCHEDULED_REPORT_ERROR, payload: errorMessage });
      });
  };

// Toggle report status - Updated to refresh all data when needed
export const toggleReportStatus =
  (email, reportName, isActive, refreshAll = false) =>
  (dispatch) => {
    dispatch({ type: TOGGLE_REPORT_STATUS_REQUEST });

    axios({
      method: 'post',
      url: `${BASE_URL}/updateSchedulerReportStatus`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        email: email,
        report_name: reportName,
        active: isActive
      },
      timeout: timeout
    })
      .then((response) => {
        if (response.data) {
          dispatch({ type: TOGGLE_REPORT_STATUS_SUCCESS, payload: response.data });

          // FIXED: Refresh appropriate data based on context
          if (refreshAll) {
            dispatch(fetchAllUserReportingEmailerDetails());
          } else {
            dispatch(fetchUserReportingEmailerDetails(email));
          }
        } else {
          dispatch({ type: TOGGLE_REPORT_STATUS_ERROR, payload: 'Failed to toggle report status' });
        }
      })
      .catch((error) => {
        let errorMessage = 'Not able to toggle report status. Please retry';
        if (error.response && error.response.data && error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        dispatch({ type: TOGGLE_REPORT_STATUS_ERROR, payload: errorMessage });
      });
  };
